/* Own only the new navigation; keep theme search/cart/mobile drawer handlers intact. */
if (!customElements.get('senil-menu')) {
  customElements.define('senil-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.addEventListener('toggle', event => {
        if (!event.target.matches('.senil-nav__top[open]')) return;
        this.querySelectorAll('.senil-nav__top[open]').forEach(detail => {
          if (detail !== event.target) detail.open = false;
        });
      }, { ...opts, capture: true });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const detail = event.target.closest('details[open]');
        if (detail) {
          detail.open = false;
          detail.querySelector('summary').focus();
          event.preventDefault();
          event.stopPropagation();
        }
      }, opts);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.querySelectorAll('.senil-nav__top[open]').forEach(d => d.open = false);
      }, opts);
    }
    disconnectedCallback() { if (this.abort) this.abort.abort(); }
  });
}
